import { loadOhCaseDetail } from "../crud/ohCase/actions";
import { routesWithoutCustomerAndOhCaseIds as taskActionSubRoutes } from "../task/taskActions/routes";

import { ADMIN_ROLES } from "../auth";

import { loadAppointmentDetail } from "./actions";
import { loadClinic } from "./clinics/actions";

export const ohCaseAppointmentRoute = {
    "/appointment/:appointmentId/:customerId/:ohCaseId": {
        title: "Appointment",
        resolve: [loadOhCaseDetail, loadAppointmentDetail],
        ...taskActionSubRoutes
    },
    "/mergedappointment/:appointmentId/:customerId/:ohCaseId": {
        title: "mergedAppointment",
        resolve: [loadOhCaseDetail, loadAppointmentDetail]
    }
};

const clinicRoutes = {
    title: "Clinic",
    "/appointment/:appointmentId/questionnaire": {
        title: "Health Surveillance/Fit for Work Questionnaire"
    },
    "/appointment/:appointmentId/consultation": {
        title: "Health Surveillance/Fit for Work Consultation"
    },
    "/appointment/:appointmentId/consultation/:taskId/repeatMedical": {
        title: "Health Surveillance/Fit for Work Consultation"
    },
    ...ohCaseAppointmentRoute
};

const bookAdHocAppointmentRoute = {
    "/clinic/:clinicId/book-ad-hoc-clinic-appointment": {
        title: "Book Ad-Hoc Appointment"
    }
};

const createTimeNoteRoute = {
    "/create-time-note": {
        title: "Create Appointment"
    }
};

export const routes = {
    "/calendar/:date": {
        title: "Calendar",
        authorize: true,
        "/clinic/:clinicId/appointment/:appointmentId": {
            title: "Appointment"
        },
        "/clinic/:clinicId": {
            resolve: loadClinic,
            ...clinicRoutes
        },
        ...bookAdHocAppointmentRoute,
        "/appointment/:appointmentId": {
            title: "Appointment",
            resolve: [loadAppointmentDetail]
        },
        ...ohCaseAppointmentRoute,
        ...createTimeNoteRoute
    },
    "/clinics/calendar/:date": {
        title: "Clinics",
        authorize: [ADMIN_ROLES.ADMINISTRATOR.name, ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name],
        "/create": {
            title: "Create Clinic"
        },
        "/create-mobile-clinic": {
            title: "Create Mobile Clinic"
        },
        "/appointment/:appointmentId": {
            title: "Appointment",
            resolve: [loadAppointmentDetail]
        },
        ...bookAdHocAppointmentRoute,
        ...createTimeNoteRoute,
        "/clinic/:clinicId/appointment/:appointmentId": {
            title: "Appointment"
        },
        "/:clinicId": clinicRoutes,
        ...ohCaseAppointmentRoute
    }
};
